export const DigestOne = {
  id: "about",
  lightBg: false,
  lightText: true,
  lightTextDesc: true,
  topLine: "About Me",
  headLine: "A little bit about me.....",
  description: `I'm a computer science student at Maynooth University undertaking a postgraduate degree in Software Development. I am adept with technologies such as HTML, CSS, JavaScript (including the React library), Java & Docker with project development experience in agile methods such as SCRUM`,
  imgStart: false,
  img: "svg-2.svg",
  alt: "Surfer",
};

export const DigestTwo = {
  id: "discover",
  lightBg: false,
  lightText: true,
  lightTextDesc: true,
  topLine: "Discovery",
  headLine: "Synopsis",
  description: `I'm a computer science student at Maynooth University undertaking a postgraduate degree in Software Development. I am adept with technologies such as HTML, CSS, JavaScript (including the React library), Java & Docker with project development experience in agile methods such as SCRUM`,
  imgStart: true,
  img: "svg-1.svg",
  alt: "Programmer",
};

export const DigestThree = {
  id: "skills",
  lightBg: false,
  lightText: true,
  lightTextDesc: true,
  topLine: "Skills",
  headLine: "My Skillset",
  description: `I'm a computer science student at Maynooth University undertaking a postgraduate degree in Software Development. I am adept with technologies such as HTML, CSS, JavaScript (including the React library), Java & Docker with project development experience in agile methods such as SCRUM`,
  imgStart: false,
  img: "svg-3.svg",
  alt: "Man in front of whiteboard",
  // button properties
  // buttonLabel: "Check it out",
  // dark: true,
  // primary: true,
  // darkText: false,
};
